module.exports = __webpack_public_path__ + "static/media/dispositions_generales_et_descriptif_des_prestations_PVO_plus.6786eacb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/go/documents/adhesion/dispositions_generales_et_descriptif_des_prestations_PVO_plus.pdf
// module id = 833
// module chunks = 40